import React from 'react';
import { ProductForm } from './ProductForm';
import { MiddlePanel } from './MiddlePanel';
import PackageContentsPanel from './PackageContentsPanel';
import { Pallet3DVisualizer } from './widgets/Pallet3DVisualizer';
import { Pallet2DVisualizer } from './widgets/Pallet2DVisualizer';
import { PalletControls } from './widgets/PalletControls';
import { LiveTrackingMap } from './widgets/LiveTrackingMap';
import { LiveTrackingDetails } from './widgets/LiveTrackingDetails';
import { PalletFlipContainer } from './widgets/PalletFlipContainer';

export const WidgetRegistry = {
    'ProductForm': ProductForm,
    'MiddlePanel': MiddlePanel,
    'PackageContentsPanel': PackageContentsPanel,
    'Pallet3DVisualizer': Pallet3DVisualizer,
    'Pallet2DVisualizer': Pallet2DVisualizer,
    'PalletControls': PalletControls,
    'LiveTrackingMap': LiveTrackingMap,
    'LiveTrackingDetails': LiveTrackingDetails,
    'PalletFlipContainer': PalletFlipContainer
};

import { usePIM } from '../context/PIMContext';

export const renderWidget = (widgetName, props = {}) => {
    const Widget = WidgetRegistry[widgetName];
    if (!Widget) {
        return <div className="text-red-500 p-4">Widget "{widgetName}" not found.</div>;
    }

    // Inject shared state for pallet widgets
    // This is a bit of a hack, ideally widgets should use the context directly
    // but passing it as props makes them more reusable/testable
    const { selectedPalletArrangement, setSelectedPalletArrangement } = usePIM();

    if (widgetName === 'Pallet3DVisualizer' || widgetName === 'Pallet2DVisualizer') {
        return <Widget arrangement={selectedPalletArrangement} {...props} />;
    }
    if (widgetName === 'PalletControls') {
        return <Widget
            selectedArrangement={selectedPalletArrangement}
            onArrangementSelected={setSelectedPalletArrangement}
            {...props}
        />;
    }

    return <Widget {...props} />;
};
